/** Available color options when creating/editing sticky notes */
export const sticky_note_color_choices = [
  '#FFEFC1',
  '#D4D5FB',
  '#FFDED0',
  '#C4E7FF',
];
